<script lang="ts">
	import { page } from '$app/stores';
	import __ from '$lib/stores/TranslationStore';
	import { ageValidator, validateNIF } from '$lib/utils/helpers/numbers';
	import Step from '../../Stepper/Step.svelte';
	import Checkbox from '../Fields/Checkbox.svelte';
	import DateInput from '../Fields/DateInput.svelte';
	import Input from '../Fields/Input.svelte';
	import PhoneNumber from '../Fields/PhoneNumber.svelte';

	const defaultFields = [
		'name',
		'email',
		'phone',
		'birthdate',
		'nif',
		'recieve_communications',
		'accept_clause'
	] as const;

	export let exceptFields: (typeof defaultFields)[number][] = [];
	$: includedFields = defaultFields.filter((field) => !exceptFields.includes(field));

	const pocketSpacing = $page.data.embed && $page.url.searchParams.get('ps') == '1';
	const defaultCode = pocketSpacing
		? $page.data.language == 'en'
			? 'US'
			: $page.data.language?.toUpperCase()
		: 'PT';
</script>

<Step
	on:complete
	title={$__('Preencha os seus <strong>dados pessoais</strong>')}
	validate={{
		name: (value) => {
			if (!/^(?=.{2,})([A-Za-zÀ-ÖØ-öø-ÿ\-]+(?:\s[A-Za-zÀ-ÖØ-öø-ÿ\-]+)+)$/.test(value)) {
				return $__('Deve colocar, no mínimo, dois nomes.');
			}
		},
		email: (value) => {
			if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
				return $__('Este formato de e-mail não é válido.');
			}
		},
		nif: (value) => {
			if (!value) return;
			if (!validateNIF(value)) {
				return $__('O NIF introduzido é inválido.');
			}
		},
        phone: (value, data) => {
            if (!value) return $__('O telemóvel introduzido é inválido.');
            if (data.data.prefix == "+351" && !/^(2\d{8}|9[1236]\d{7}|3[0]\d{7}|7[0]\d{7})$/.test(value)) {
                return $__('O telemóvel introduzido é inválido.');
            }
        },
        birthdate: (value) =>{
            if(!/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/.test(value)){
                return $__('Data de nascimento inválida.');
            }
            if(!ageValidator(value, 18)){
                return $__('Deve ter no mínimo 18 anos.');
            }
        }
	}}
	required={['name', 'email', 'phone', 'birthdate', 'accept_clause']}
	displayCaption={(step) => `
		${step.data.name}
		<br />
		${step.data.email}
		<br />
		${step.data.prefix} ${step.data.phone}
		<br />
		${step.data.birthdate}
		<br />
		${step.data.nif ? 'NIF ' + step.data.nif : ''}
	`}
>
	<div class="flex flex-col gap-6">
		{#if includedFields.includes('name')}
			<Input name="name" label={$__('Nome e apelido')} />
		{/if}
		{#if includedFields.includes('email')}
			<Input name="email" label="E-mail" />
		{/if}
		{#if includedFields.includes('phone')}
			<PhoneNumber {defaultCode} name="phone" label={$__('Telemóvel')} />
		{/if}
		{#if includedFields.includes('birthdate') && includedFields.includes('nif')}
			<div class="flex flex-col gap-7 lg:flex-row">
				<DateInput name="birthdate" label={$__('Data de nascimento')} />
				<Input inputmode="numeric" name="nif" label={$__('NIF')} />
			</div>
		{:else if includedFields.includes('birthdate')}
			<DateInput name="birthdate" label={$__('Data de nascimento')} />
		{:else if includedFields.includes('nif')}
			<Input inputmode="numeric" name="nif" label={$__('NIF')} />
		{/if}
		{#if includedFields.includes('recieve_communications')}
			<Checkbox
				name="recieve_communications"
				label={$__('Quero receber comunicações do Poupança no Minuto por e-mail')}
			/>
		{/if}
		{#if includedFields.includes('accept_clause')}
			<Checkbox
				name="accept_clause"
				label={$__(
					'Li e aceito a cláusula de <a class="text-primary visited:text-secondary" target="__blank" href="/politica-de-protecao-de-dados">Proteção de dados</a>.'
				)}
			/>
		{/if}
	</div>
</Step>
